const INTERNAL_URL_BASE = "https://internal.invalid";
const SAFE_EXTERNAL_PROTOCOLS = new Set(["https:", "mailto:", "tel:"]);

function isNonEmptyString(value: unknown): value is string {
  return typeof value === "string" && value.trim().length > 0;
}

/**
 * Accepts relative application URLs and explicitly allowed external schemes.
 * Protocol-relative URLs and active-content schemes are rejected.
 */
export function normalizeButtonLinkHref(value: unknown): string | null {
  if (!isNonEmptyString(value)) return null;

  const trimmedValue = value.trim();
  // URL parsers treat backslashes like slashes in special schemes, so any
  // two leading slash/backslash characters form a protocol-relative URL.
  if (/^[/\\]{2}/.test(trimmedValue)) {
    return null;
  }

  try {
    const parsedUrl = new URL(trimmedValue, INTERNAL_URL_BASE);
    const isRelativeUrl = parsedUrl.origin === INTERNAL_URL_BASE;

    if (isRelativeUrl) {
      return trimmedValue;
    }

    if (SAFE_EXTERNAL_PROTOCOLS.has(parsedUrl.protocol)) {
      return trimmedValue;
    }
  } catch {
    // Invalid URLs are rejected below.
  }

  return null;
}
